import { render, staticRenderFns } from "./UpcomingBirthdays.vue?vue&type=template&id=213b8bf8&scoped=true"
import script from "./UpcomingBirthdays.vue?vue&type=script&lang=js"
export * from "./UpcomingBirthdays.vue?vue&type=script&lang=js"
import style0 from "./UpcomingBirthdays.vue?vue&type=style&index=0&id=213b8bf8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "213b8bf8",
  null
  
)

export default component.exports